import { PapiGallection } from '@wix/da-types-papi';
import { ALL_FOLDER_ID } from '@wix/da-url';
import stickyBarStyles from './StickyBar/StickyBar.scss';

export function getGallectionsStickyBarHeight(isMobile): number {
  return parseInt(
    isMobile
      ? stickyBarStyles['folder-bar-mobile-height']
      : stickyBarStyles['folder-bar-height']
  );
}

export function getCommentsBlockAnchor(folderId) {
  return `folder-comments-${folderId}`;
}

export const getAllFolderFromFolders = (folders: PapiGallection[]) =>
  folders.find(({ folderId }) => folderId === ALL_FOLDER_ID);

export const getFeaturedFolderFromFolders = (folders: PapiGallection[]) =>
  folders.find(({ name }) => name === 'Featured');

export function getDefaultFolderFromFolders(
  folders: PapiGallection[]
): PapiGallection {
  const featuredFolder = getFeaturedFolderFromFolders(folders);
  if (featuredFolder && featuredFolder.size) {
    return featuredFolder;
  }
  return getAllFolderFromFolders(folders)!;
}
